import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import "./img.css";
import LatestUpdates from "./latestupdates";
import { Container, Row, Col, Card, ListGroup, Button, Image, Table } from "react-bootstrap";
import { FaFacebook, FaTiktok, FaYoutube, FaInstagram, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Footer from './footer';

const HeroSection = () => (
    <div className="bg-light p-4 text-center">
        <h1 className="fw-bold">Skilled Nominated Visa (Subclass 190)</h1>
    </div>
);

const ContentSection = () => (
    <Col md={8}>
       
            <div className="ratio ratio-16x9">
                <iframe
                    width="100%"
                    height="400"
                    src="https://www.youtube.com/embed/rwEEjSHjqpg"
                    title="YouTube video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
            </div>
       
        <p>
            This visa lets nominated skilled workers live and work in Australia as permanent residents.
        </p>
        <p>You can be in or outside Australia when you apply for the visa and when we decide your
            application but not in immigration clearance.</p>
        <p>If you apply in Australia, you must hold a substantive visa or a Subclass 010 Bridging
            A visa, a Subclass 020 Bridging B visa or a Subclass 030 Bridging C visa, otherwise
            your application will not be valid.</p>
        <h4>THE APPLICATION PROCESS</h4>
        <p><b>Step 1:</b> Check if your occupation is on the SOL, and that you have 65 points as a minimum</p>
        <p><b>Step 2:</b> Submit an expression of interest</p>
        <p><b>Step 3:</b>Wait for invitation to apply</p>
        <p><b>Step 4:</b>Gather your documents </p>
        <p><b>Step 5:</b>Apply for your visa within 60 days of invitation.</p>
        <p><b>Step 1: </b>a sponsorship application by the employer (the employer needs to be a lawfull,
            active, operating business and meet local labour and employment practices).
        </p>
        <p><b>Step 2:</b>The second pAAT of the application process is the nomination application. This is
            regarding the position to be filled, salary details, efforts to hire Australian workers and the
            ‘genuineness’ of the position. The business must also be viable to sponsor from overseas.</p>
        <p><b>Step 3:</b>a visa application by the nominated employee. The visa applicant must demonstrate
            that they meet the skills required for their occupation as well as health and character requirements.
        </p>



        <h4>WHAT YOU CAN DO</h4>
        <p>This visa allows you to:</p>
        <ul>
            <li>stay in Australia permanently</li>
            <li>do work or activity specified in your application</li>
            <li>enter and leave Australia as many times as you want while your visa is valid.</li>
            <li>Sponsor eligible relatives for Pemanent residency.</li>

        </ul>
        <h4>VISA STREAMS</h4>

        <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 stAAT-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>

    </Col>
);




const Sidebar = () => (
    <Col md={3}>
       <Col md={12}>
    <div style={{ maxWidth: "800px", width: "100%" }}>
        <Card className="border-0 shadow-none">
        <Card.Header className="fw-bold">Latest Posts</Card.Header>
            <ListGroup variant="flush">
                <ListGroup.Item className="border-0"><Link to="/professional" className="dropdown-item"> <a href="" className="text-decoration-none">Professional Year</a> </Link></ListGroup.Item>
                <ListGroup.Item className="border-0"><Link to="/coursechange" className="dropdown-item"> <a href="" className="text-decoration-none">Admissions And Course Change </a></Link></ListGroup.Item>
                <ListGroup.Item className="border-0"><Link to="/skilledID" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Independent Visa (Subclass 189)</a></Link></ListGroup.Item>
                <ListGroup.Item className="border-0"><Link to="/workregionalvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</a></Link></ListGroup.Item>
                <ListGroup.Item className="border-0"><Link to="/nominatedvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</a></Link></ListGroup.Item>
               <ListGroup.Item><a href="https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/skilled-regional-191"
                                    className="dropdown-item text-decoration-none "
                                    style={{ color: "#22327f" }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Permanent Residence visa (Subclass 191)
                                  </a>
                                </ListGroup.Item>
                <ListGroup.Item className="border-0"><Link to="/tempactivity" className="dropdown-item"><a href="" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</a></Link></ListGroup.Item>
            </ListGroup>
        </Card>
    </div>
</Col>


                  

        {/* YouTube & Social Media Section */}
        <Card className="p-3 text-center mt-4"> {/* Added spacing between sidebar and card */}
            <Image src="./img/brand-logo.png" alt="Bajwa Immigration Logo" fluid className="mb-3" />

            <h6 className="fw-bold">Subscribe to our YouTube channel</h6>
            <Button variant="danger" className="mb-3"><a href="https://www.youtube.com/embed/uOGAB9oYets" >SUBSCRIBE </a></Button>

            <h6 className="fw-bold">Book Consultation</h6>
            <Button variant="warning">BOOK CONSULTATION</Button>

            <h6 className="fw-bold mt-3">Like Us on Facebook !!</h6>
            <iframe
                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FBajwaImmigration&tabs&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                width="100%"
                height="130"
                style={{ border: "none", overflow: "hidden" }}
                scrolling="no"
                frameBorder="0"
                allowFullScreen
            ></iframe>

            <h6 className="fw-bold mt-3">We are also on:</h6>
            <div className="d-flex justify-content-center gap-3">
                <FaInstagram size={30} color="#C13584" />
                <FaTiktok size={30} color="#000" />
                <FaYoutube size={30} color="crimson" />
            </div>
        </Card>
    </Col>
);


const NomVisa = () => (
    <>
        <Container className="mt-4">
            <HeroSection />
            <Row className="mt-4 gap-4"> {/* Added gap-4 for spacing between content and sidebar */}
                <ContentSection />
                <Sidebar />

            </Row>
        </Container>
       
        <LatestUpdates />
        <Footer />
    </>
);

export default NomVisa;
